import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import * as styles from 'src/uglib_styles/banners.module.css'
import Notices from './notices';
import Notice from './notice';

function Banners () {

    const data = useStaticQuery(graphql`
       query BannerQuery {
            banners: allNodeBanner(sort: {created: DESC}) {
                edges {
                    node {
                        id
                        field_banner_icon
                        field_banner_colour
                        field_banner_message {
                            processed
                        }
                    }
                }
            }
        }
    `)

    const banners = data.banners.edges;

    const colours = new Map();
    colours.set('ug_red', 'var(--uog-color-red)');
    colours.set('ug_blue', 'var(--uog-color-blue)');
    colours.set('ug_yellow', 'var(--uog-color-yellow)');
    colours.set('grey', 'var(--uog-color-grey-dark)');
    colours.set('black', 'black');

    const rendered_banners = banners.map((banner) => (
        <Notice key={banner.node.id} icon={banner.node.field_banner_icon} color={colours.get(banner.node.field_banner_colour)} grow={1}>
            <div className={styles.message} dangerouslySetInnerHTML={{__html: banner.node.field_banner_message.processed}} />
        </Notice>
    ));

    if (rendered_banners.length < 1) {
        return(<></>)
    }
    
	return (
        <Notices>
            {rendered_banners}
        </Notices>
    );
}

export default Banners